import { jsx } from "react/jsx-runtime";
import { styled } from "@linaria/react";
import { typographyClassName } from "@creditornot/cb-ingredients";
import { clsx } from "@creditornot/cb-utils";
import "./style.css";
const Root = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_Avatar_Root_rezw",
  propsAsIs: false
});
const AvatarImage = /* @__PURE__ */ styled("img")({
  name: "AvatarImage",
  class: "cb_Avatar_AvatarImage_au87",
  propsAsIs: false
});
const Avatar = ({
  className,
  imgAlt = "",
  imgProps,
  imgSizes,
  imgSrc,
  imgSrcSet,
  initials = "",
  size = "small",
  ...rest
}) => /* @__PURE__ */ jsx(Root, {
  className: clsx(className, {
    [typographyClassName.bodyBase]: size === "extraTiny",
    [typographyClassName.Overline4]: size === "tiny",
    [typographyClassName.Overline3]: size === "small",
    [typographyClassName.Overline2]: size === "medium",
    [typographyClassName.Overline1]: size === "large" || size === "extraLarge"
  }),
  "data-clickable": !!rest.onClick,
  "data-size": size,
  ...rest,
  children: imgSrc ? /* @__PURE__ */ jsx(AvatarImage, {
    ...imgProps,
    alt: imgAlt,
    sizes: imgSizes,
    src: imgSrc,
    srcSet: imgSrcSet
  }) : initials
});
const Avatar$1 = Avatar;
export {
  Avatar$1 as Avatar
};
//# sourceMappingURL=index.js.map
